import { queryParams } from '@/plugins/axios';

export function all(context, payload) {
  const { params } = payload;
  const getUrl = `/children${queryParams(params)}`;

  return this._vm.$axios.get(getUrl).then((response) => {
    const { data } = response;
    console.log('store.children.actions.all() axios then', data);

    return context.dispatch('setChildren', { data: data.posts });
  });
}

export function setChildren(context, payload) {
  // console.log('store.children.actions.setChildren()', payload);
  context.commit('setChildren', payload.data);

  return payload.data;
}
